import { LibraryExerciseAnswer } from "./LibraryExerciseAnswer";

export class LibraryAsset {
    id: number;
    type: "article"|"assignment";
    originalCreator:string;
    title: string;
    description: string;
    content: string;
    journal: string;
    creationDate: Date
    lastUpdateDate: Date;
    tags:string[];

    public getAnswerIdPrefix() {
        return 'answer-id-';
    }

    public hasTag(tag:string) {
        return this.tags && this.tags.indexOf(tag) >= 0;
    }

    public titleContainsString(str:string) {
        if (!this.title || this.title.trim() =="") {
            return false;
        }
        return this.title.toLowerCase().indexOf(str.toLowerCase()) >= 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/library-assets/models/library-asset.ts